import script from "./AudioPlayerWithSubtitles.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioPlayerWithSubtitles.vue?vue&type=script&setup=true&lang=js"

import "./AudioPlayerWithSubtitles.vue?vue&type=style&index=0&id=d56fbda6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d56fbda6"]])

export default __exports__